<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="add"
      >新增</a-button
    >
    <a-modal v-model="visible" centered title="添加手机号码" @ok="handleOk">
      <p>手机号码</p>
      <a-input v-model="form.phone" placeholder="请输入11位手机号码"></a-input>
    </a-modal>
    <a-modal v-model="visibletwo" centered title="编辑手机号码" @ok="handleOktwo">
      <p>手机号码</p>
      <a-input v-model="forms.phone" placeholder="请输入11位手机号码" ></a-input>

    </a-modal>
    
    <a-table
      :columns="columns"
      :row-key="record => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="edit(operate)">编辑</a>
        <a href="javascript:;" @click="del(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  storeGetDisablePhoneList,
  storeAddDisablePhone,
  storeEditDisablePhone,
  storeDelDisablePhone
} from "@/api/storeApi.js";
import { message } from "ant-design-vue";
import { validatePhone } from "@/utils/validatePhone.js";
const columns = [
  {
    title: "ID",
    dataIndex: "objId",
    align: "center",
    scopedSlots: { customRender: "objId" }
  },
  {
    title: "手机号码",
    dataIndex: "phone",
    align: "center",
    scopedSlots: { customRender: "phone" }
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    align: "center",
    scopedSlots: { customRender: "createTime" }
  },
  {
    title: "修改时间",
    dataIndex: "updateTime",
    align: "center",
    scopedSlots: { customRender: "updateTime" }
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" }
  }
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: total => `共 ${total} 条`,
        pageSize: 10
      },
      loading: false,
      columns,
      visible: false,
      visibletwo: false,
      form: {
        phone: null,
      },
      forms: {
        objId: "",
        phone: null,
      }
    };
  },
  mounted() {
    this.getData();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      this.loading = true;
      this.pagination.current = pagination.current;
      const data ={
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
       //重置当前页
      storeGetDisablePhoneList(data).then(res => {
        this.data = res.data;
        this.pagination.total = res.count;
        this.loading = false;
      });
    },
    edit(row) {
      this.visibletwo = true;
      this.forms.objId = row.objId;
      this.forms.phone = row.phone;

    },

    // 查询
    query() {
      const data ={
        phone: this.formInline.phone,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      this.loading = true;
      storeGetDisablePhoneList(data).then(res => {
        if(res.data == null){
            message.warning("没有数据");
            this.data = [];
            this.pagination.total = 0;
            this.loading = false;
            return;
        }
        this.pagination.total = res.count;
        this.data = res.data;
        this.loading = false;
      });
    },
    del(row) {
      this.loading = true;
      storeDelDisablePhone(row.objId).then(res => {
        this.loading = false;
        this.pagination.current = 1;
        this.getData();
        message.success(res.info);
      });

    },
    add() {
      this.visible = true;
      // 重新初始化表单，确保类型正确
      this.form = {
        phone: null,
      };
    },
    handleOk() {
      if(!validatePhone(this.form.phone)){
        return;
      }
 
      // 创建新的表单对象，确保使用正确的数据类型
      const submitForm = {
        phone: this.form.phone,
      };
      
      this.visible = false;
      console.log("submit form data:", submitForm);
      storeAddDisablePhone(submitForm).then(res => {
        message.success(res.info);
        this.getData();
         this.form = {
                phone: null,
            };
      });
    },
    handleOktwo() {

      if(!validatePhone(this.forms.phone)){
        return;
      }
 
      // 创建新的表单对象，确保使用正确的数据类型
      const submitForms = {
        objId: this.forms.objId,
        phone: this.forms.phone,
      };
      console.log("update submit forms:", submitForms);
      
      this.visibletwo = false;
      storeEditDisablePhone(submitForms).then(res => {
        message.success(res.info);
        this.getData();
      });
    },
    getData() {
      const data ={
        phone: this.formInline.phone,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      storeGetDisablePhoneList(data).then(res => {
        // console.log("getData res ------", res);
        if(res.data == null){
            message.warning("没有数据");
            this.data = [];
            this.pagination.total = 0;
            this.loading = false;
            return;
        }
        this.pagination.total = res.count;
        this.data = res.data;
      });
    }
  }
};
</script>
<style scoped>
img {
  width: 110px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/storeManagement/disablePhoneManagement/disablePhoneContent.vue